const berlinTimeZone = "Europe/Berlin";
const germanDateTimePattern = /^(\d{1,2})\.(\d{1,2})\.(\d{4})(?:\s+(\d{1,2}):(\d{2})(?::(\d{2}))?)?$/;
const berlinDateTimeFormatter = new Intl.DateTimeFormat("en-CA", {
  day: "2-digit",
  hour: "2-digit",
  hourCycle: "h23",
  minute: "2-digit",
  month: "2-digit",
  second: "2-digit",
  timeZone: berlinTimeZone,
  year: "numeric",
});

function berlinWallClockToIso(year: number, month: number, day: number, hour: number, minute: number, second: number) {
  const wallClockMillis = Date.UTC(year, month - 1, day, hour, minute, second);
  const wallClockDate = new Date(wallClockMillis);
  if (
    wallClockDate.getUTCFullYear() !== year ||
    wallClockDate.getUTCMonth() !== month - 1 ||
    wallClockDate.getUTCDate() !== day ||
    wallClockDate.getUTCHours() !== hour ||
    wallClockDate.getUTCMinutes() !== minute ||
    wallClockDate.getUTCSeconds() !== second
  ) {
    return null;
  }

  let utcMillis = wallClockMillis;
  for (let attempt = 0; attempt < 3; attempt += 1) {
    const parts = Object.fromEntries(
      berlinDateTimeFormatter
        .formatToParts(new Date(utcMillis))
        .filter((part) => part.type !== "literal")
        .map((part) => [part.type, part.value])
    );
    const representedWallClockMillis = Date.UTC(
      Number(parts.year),
      Number(parts.month) - 1,
      Number(parts.day),
      Number(parts.hour),
      Number(parts.minute),
      Number(parts.second)
    );
    const adjustment = wallClockMillis - representedWallClockMillis;
    if (adjustment === 0) break;
    utcMillis += adjustment;
  }

  return new Date(utcMillis).toISOString();
}

export function normalizeSourceOrderDate(value: unknown) {
  const raw = String(value ?? "").trim();
  if (!raw) return null;

  const firstRangeDate = raw.split(/\s+\bto\b\s+/i)[0]?.trim() || raw;
  const germanMatch = firstRangeDate.match(germanDateTimePattern);
  if (germanMatch) {
    const normalized = berlinWallClockToIso(
      Number(germanMatch[3]),
      Number(germanMatch[2]),
      Number(germanMatch[1]),
      Number(germanMatch[4] || 0),
      Number(germanMatch[5] || 0),
      Number(germanMatch[6] || 0)
    );
    return normalized || raw;
  }

  const directlyParsed = new Date(firstRangeDate);
  if (!Number.isNaN(directlyParsed.getTime())) return directlyParsed.toISOString();

  const normalizedText = firstRangeDate.replace(/\b(Mär|Mrz)\.?\b/gi, "Mar").replace(/\./g, "");
  const parsed = new Date(normalizedText);
  return Number.isNaN(parsed.getTime()) ? raw : parsed.toISOString();
}
